// extracted by mini-css-extract-plugin
module.exports = {"rightPanel":"rightPanelStyles__rightPanel--FQmuQ","fullHeight":"rightPanelStyles__fullHeight--m2pG-","image":"rightPanelStyles__image--11Qrh"};